import React, { useEffect, useState } from "react"
import { useSubheader } from "../../../../../_metronic/layout/index.js"
import { useDispatch, useSelector } from "react-redux"
import { Card } from "react-bootstrap"
import { CardBody } from "../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../component/atoms/RowModule/RowModule.jsx"
import { DetailText, RowText, TableSkeleton } from "../../../../../component/index.jsx"
import BootstrapTable from "react-bootstrap-table-next"
import {
  getDetailHarvestEstimation,
  updateAreaActivityImage
} from "../../../../../redux/actions/AreaAction.jsx"
import { timeStampToDate } from "../../../../helpers/DateHelper.js"
import { toMeter, toRupiah } from "../../../../helpers/TextHelper.js"
import { AREA, GENERAL } from "../../../../../constants/InitTypeConstants.js"
import { RoutesConstants } from "../../../../../constants/RoutesConstants.js"
import { ICON_CONSTANTS } from "../../../../../constants/ImageConstants.js"
import { ActivityDetailHeader } from "../../../../../component/molecule/ActivityDetailHeader/ActivityDetailHeader.jsx"
import { useTranslation } from "react-i18next"

export const HarvestEstimationDetail = ({
  match: {
    params: { status, id, activity_id }
  }
}) => {
  const subHeader = useSubheader()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { MasterData, General, Area } = useSelector((state) => state)
  const [detail, setDetail] = useState({})
  const [idDocument, setIdDocument] = useState(null)

  useEffect(() => {
    dispatch(getDetailHarvestEstimation(activity_id))
  }, [])

  useEffect(() => {
    if (Area.data) {
      setDetail(Area.data)
    }
  }, [Area])

  useEffect(() => {
    subHeader.setButton(null)
    subHeader.setBreadcrumbs([
      {
        pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
        title: t("label_area_name")
      },
      {
        pathname: RoutesConstants.AREA.LIST_AREA_TEREGISTRASI(status),
        title: t("label_registered")
      },
      {
        pathname: RoutesConstants.AREA.DETAIL_AREA(status, id),
        title: detail?.activity_header?.area_name
      },
      {
        title: t("label_harvest_estimation")
      }
    ])
  }, [detail])

  useEffect(() => {
    if (General.isFinishUpdateOrDelete) {
      if (General.actionInitType === GENERAL.UPLOAD) {
        const data = {
          id: detail?.activity_header?.image_and_id_activity[idDocument]?.id,
          url: MasterData.urlResponseUpload
        }

        dispatch(updateAreaActivityImage(data))
      } else if (General.actionInitType === AREA.UPDATE_ACTIVITY_IMAGE) {
        dispatch(getDetailHarvestEstimation(activity_id))
      }
    }
  }, [General])

  const titleActivity = (
    <ActivityDetailHeader
      title={t("card_title_harvest_estimation_activity").toUpperCase()}
      icon={ICON_CONSTANTS.ACTIVITY_ICONS.HARVEST_ESTIMATION}
    />
  )

  const areaInformation = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-6 text-uppercase"}>{t("label_area_information").toUpperCase()}</h4>
        <RowModule customColumnCss={"col-md-6 mb-2"}>
          <RowModule>
            <RowText
              label={t("label_area_name")}
              value={detail?.area_information?.area_name ?? "-"}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={`${t("label_land_area_total")} (Manual)`}
              value={
                detail?.area_information?.area_land_manual
                  ? toMeter(detail?.area_information?.area_land_manual)
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              hasIcon={detail?.area_information?.has_kur}
              icon={detail?.area_information?.bank_image}
              label={t("label_farmer")}
              value={
                detail?.area_information?.farmer_name
                  ? `${detail?.area_information?.farmer_name} (${detail?.area_information?.farmer_code})`
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              label={`${t("label_land_area_total")} (Polygon)`}
              value={
                detail?.area_information?.area_land_polygon
                  ? toMeter(detail?.area_information?.area_land_polygon)
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              label={"Mitra"}
              value={
                detail?.area_information?.mitra_name
                  ? `${detail?.area_information?.mitra_name} (${detail?.area_information?.mitra_code})`
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText label={t("label_plant_type")} value={detail?.plant_name ?? "-"} />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_area_location")}
              value={detail?.area_information?.full_address ?? "-"}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_plant_varieties")}
              value={detail?.area_information?.variety_name ?? "-"}
            />
          </RowModule>
        </RowModule>
      </CardBody>
    </Card>
  )

  const detailActivitas = (
    <Card className={"mb-4"}>
      <CardBody>
        <h4 className={"mb-6 mt-6 text-uppercase"}>{t("label_activity_detail")}</h4>
        <RowModule customColumnCss={"col-md-6 mb-2"}>
          <RowModule>
            <RowText
              label={t("label_submitted_by")}
              value={detail?.activity_header?.submitted_by ?? "-"}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={`${t("label_estimated_land_area_worked")} (Alsintan)`}
              value={
                detail?.activity_header?.worked_area
                  ? toMeter(detail?.activity_header?.worked_area)
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_submitted_time")}
              value={
                detail?.activity_header?.submitted_date
                  ? timeStampToDate(detail?.activity_header?.submitted_date, "dd-MM-yyyy HH:mm:ss")
                  : "-"
              }
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_harvest_estimation")}
              value={`${detail?.start_estimated_date} s/d ${detail?.end_estimated_date}` ?? "-"}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_requested_by")}
              value={detail?.activity_header?.request_by_string ?? "-"}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={"HST"}
              value={isNaN(detail?.hst_harvest) ? "-" : `${detail?.hst_harvest} HST`}
            />
          </RowModule>
          <RowModule>
            <RowText
              label={t("label_survey_date")}
              value={
                detail?.activity_header?.activity_date
                  ? timeStampToDate(detail?.activity_header?.activity_date, "dd-MM-yyyy")
                  : "-"
              }
            />
          </RowModule>
        </RowModule>
        {detail?.activity_header?.image_and_id_activity.length > 0 ||
        detail?.activity_header?.note ? (
          <div className={"my-10"}>
            <h4 className={"mb-6"}>{t("label_note").toUpperCase()}</h4>
            <div className={"row mb-4"}>
              {detail?.activity_header?.image_and_id_activity.map((item, index) => {
                return (
                  <div className={"col-md-3"} key={index}>
                    <DetailText
                      type="image"
                      value={item.url}
                      indexKey={index}
                      menu={AREA.ACTIVITY_HARVEST_ESTIMATED}
                      setIdDocument={setIdDocument}
                    />
                  </div>
                )
              })}
            </div>
            <span className="font-weight-bold text-dark-50 font-size-sm">
              {detail?.activity_header?.note ?? "-"}
            </span>
          </div>
        ) : null}
      </CardBody>
    </Card>
  )

  const columns = [
    {
      dataField: "no",
      text: "No",
      headerClasses: "bg-gray"
    },
    {
      dataField: "parameter",
      text: "Parameter",
      headerClasses: "bg-gray"
    },
    {
      dataField: "harvest_estimate",
      text: t("label_harvest_estimation"),
      headerClasses: "bg-gray"
    }
  ]

  const dataEstimate = () => {
    return [
      {
        no: "1",
        parameter: t("label_harvest_age"),
        harvest_estimate: isNaN(detail?.hst_harvest) ? "-" : `${detail?.hst_harvest} HST`
      },
      {
        no: "2",
        parameter: `${t("label_price")} per Kg`,
        harvest_estimate: detail?.price_per_kg ? toRupiah(detail?.price_per_kg) : "-"
      },
      {
        no: "3",
        parameter: t("label_weight"),
        harvest_estimate: detail?.weight ? detail?.weight + " Kg" : "-"
      }
    ]
  }

  const estimated = (
    <>
      {General.loading ? (
        <TableSkeleton column={4} row={3} />
      ) : (
        <Card>
          <CardBody>
            <h4 className={"mb-6"}>DATA {t("label_harvest_estimation")}</h4>
            <div className={"border rounded table-small-padding"}>
              <BootstrapTable
                condensed
                bordered={false}
                columns={columns}
                keyField={"name"}
                data={dataEstimate(detail?.plant_name)}
              />
            </div>
          </CardBody>
        </Card>
      )}
    </>
  )

  return (
    <>
      {titleActivity}
      {areaInformation}
      {detailActivitas}
      {estimated}
    </>
  )
}
